import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "bg-white" }
const _hoisted_3 = { class: "px-6 py-16 sm:px-6 sm:py-32 lg:px-8" }
const _hoisted_4 = { class: "mx-auto max-w-2xl text-center" }
const _hoisted_5 = { class: "text-4xl font-semibold tracking-tight text-balance text-gray-900 sm:text-5xl" }
const _hoisted_6 = { class: "mt-10 flex items-center justify-center gap-x-6" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "mt-6 grid grid-cols-1" }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "bg-white shadow-xs rounded-lg p-4 mb-4" }
const _hoisted_12 = {
  key: 0,
  class: "bg-white"
}
const _hoisted_13 = { class: "px-6 py-16 sm:px-6 sm:py-32 lg:px-8" }
const _hoisted_14 = { class: "mx-auto max-w-2xl" }
const _hoisted_15 = { class: "text-center text-4xl font-semibold tracking-tight text-balance text-gray-900 sm:text-5xl" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "mt-10 flex items-center justify-center gap-x-6" }
const _hoisted_18 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_19 = { class: "mt-1 text-md text-gray-900" }
const _hoisted_20 = { class: "px-4 py-6 sm:px-6" }
const _hoisted_21 = { class: "space-y-8" }
const _hoisted_22 = { class: "text-sm font-medium text-gray-500 sm:shrink-0" }
const _hoisted_23 = { class: "italic text-gray-500 mt-2" }
const _hoisted_24 = { class: "text-sm text-gray-900 sm:col-span-2 mt-4" }
const _hoisted_25 = { class: "text-sm font-medium text-gray-500 sm:shrink-0" }
const _hoisted_26 = { class: "italic text-gray-500 mt-2" }
const _hoisted_27 = { class: "text-sm text-gray-900 sm:col-span-2 mt-4" }
const _hoisted_28 = { class: "text-sm font-medium text-gray-500 sm:shrink-0" }
const _hoisted_29 = { class: "italic text-gray-500 mt-2" }
const _hoisted_30 = { class: "text-sm text-gray-900 sm:col-span-2 mt-4" }
const _hoisted_31 = { class: "text-sm font-medium text-gray-500 sm:shrink-0" }
const _hoisted_32 = { class: "italic text-gray-500 mt-2" }
const _hoisted_33 = { class: "text-sm text-gray-900 sm:col-span-2 mt-4" }
const _hoisted_34 = { class: "text-sm font-medium text-gray-500 sm:shrink-0" }
const _hoisted_35 = { class: "italic text-gray-500 mt-2" }
const _hoisted_36 = { class: "text-sm text-gray-900 sm:col-span-2 mt-4" }
const _hoisted_37 = { class: "text-sm font-medium text-gray-500 sm:shrink-0" }
const _hoisted_38 = { class: "italic text-gray-500 mt-2" }
const _hoisted_39 = { class: "text-sm text-gray-900 sm:col-span-2 mt-4" }

import {
  onBeforeMount, ref, computed,
} from 'vue';
import Plugin from '@/models/plugin/plugin';
import InstagramLiveMetadata from '@/models/plugin/instagramLiveMetadata';
import FacebookLiveMetadata from '@/models/plugin/facebookLiveMetadata';
import usePluginStore from '@/store/plugin/plugin';
import RightSideDrawer from '@/components/tailwind/shared/RightSideDrawer.vue';
import ListPluginReportsTable from '@/components/tailwind/plugin/ListPluginReportsTable.vue';
import PluginHeader from '@/components/tailwind/plugin/PluginHeader.vue';
import PluginConnectDrawer from '@/components/tailwind/plugin/PluginConnectDrawer.vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

const pageLimit = 5;

export default /*@__PURE__*/_defineComponent({
  __name: 'ListPluginReportsDashboard',
  props: {
  plugins: {
    type: () => [] as Plugin[],
    required: true,
  },
},
  setup(__props) {

const router = useRouter();
const { t } = useI18n();
const {
  pluginGetInstagramLiveMetadatas,
  pluginGetFacebookLiveMetadatas,
} = usePluginStore();

/*
  Props
*/
const props = __props;

/*
  Data
*/
const dataLoaded = ref(false);
const showHelpModal = ref(false);
const showCreateModal = ref(false);
const metadataHash = ref({} as Record<string, {
  plugin: Plugin, metadatas: (InstagramLiveMetadata | FacebookLiveMetadata)[]
}>);

/*
  Computed
*/
const sortedMetadataArray = computed(() => Object.values(metadataHash.value).sort((a, b) => {
  const aCreatedAt = a.metadatas && a.metadatas.length > 0 ? a.metadatas[0]?.createdAt : null;
  const bCreatedAt = b.metadatas && b.metadatas.length > 0 ? b.metadatas[0]?.createdAt : null;

  const aDate = aCreatedAt ? new Date(aCreatedAt) : null;
  const bDate = bCreatedAt ? new Date(bCreatedAt) : null;

  const aHasValidDate = aDate && !Number.isNaN(aDate.getTime());
  const bHasValidDate = bDate && !Number.isNaN(bDate.getTime());

  // Case 1: Both have valid dates
  if (aHasValidDate && bHasValidDate) {
    if (aDate.getTime() !== bDate.getTime()) {
      return bDate.getTime() - aDate.getTime(); // Sort by date descending
    }
    // Dates are equal, fall through to sort by name ascending (as a tie-breaker)
  } else if (aHasValidDate && !bHasValidDate) {
    return -1; // 'a' comes first
  } else if (!aHasValidDate && bHasValidDate) {
    return 1; // 'b' comes first
  }
  // Case 4: Neither has a valid date (or dates were equal and need tie-breaking)
  // Fall back to sorting by plugin.name ascending
  return a.plugin.name.localeCompare(b.plugin.name);
}));

const hasOnePluginAndNoMetadatas = computed(
  () => Object.keys(metadataHash.value).length === 1
  && metadataHash.value[Object.keys(metadataHash.value)[0]]?.metadatas.length === 0,
);

/*
  Methods
*/
const openPluginLivesPage = async () => {
  await router.push({
    name: 'PluginDashboardPage',
    params: {
      pluginId: props.plugins[0].id,
      pluginType: props.plugins[0].type,
    },
    query: {
      tab: 'lives',
    },
  });
};
const navigateWhatsapp = (message: string) => {
  window.open(`https://wa.me/+5511994991786?text=${message}`, '_blank');
};

const loadMetadatas = async (plugin: Plugin) => {
  const fetchMetadatas = plugin.type === 'facebook'
    ? pluginGetFacebookLiveMetadatas({
      pluginId: `${plugin.id}`,
      page: 1,
      limit: pageLimit,
      orderBy: 'createdAt',
      order: -1,
    })
    : pluginGetInstagramLiveMetadatas({
      pluginId: `${plugin.id}`,
      page: 1,
      limit: pageLimit,
      orderBy: 'createdAt',
      order: -1,
    });

  await fetchMetadatas.then((response) => {
    if (response) {
      metadataHash.value[plugin.name] = {
        plugin,
        metadatas: response.data,
      };
    }
  }).catch((error) => {
    console.error('error', error);
  });
};

/*
  Hooks
*/
const loadPluginsInBatches = async () => {
  const batchSize = 30;
  // eslint-disable-next-line no-await-in-loop
  for (let i = 0; i < props.plugins.length; i += batchSize) {
    const batch = props.plugins.slice(i, i + batchSize);
    // eslint-disable-next-line no-await-in-loop
    await Promise.all(batch.map((plugin: Plugin) => loadMetadatas(plugin)));
  }
  dataLoaded.value = true;
};

onBeforeMount(() => {
  if (props.plugins.length === 0) {
    dataLoaded.value = true;
  } else {
    loadPluginsInBatches();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_DialogTitle = _resolveComponent("DialogTitle")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.plugins.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref(t)('dashboard.plugin.calltoaction.title')), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("a", {
                    href: "#",
                    class: "rounded-md bg-teal-500 px-3.5 py-2.5 text-lg font-semibold text-white shadow-xs hover:bg-teal-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-700",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showCreateModal.value = true), ["prevent"]))
                  }, _toDisplayString(_unref(t)('dashboard.plugin.calltoaction.button')), 1),
                  _createElementVNode("a", {
                    href: "#",
                    class: "text-sm/6 font-semibold text-gray-900",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (showHelpModal.value = true), ["prevent"]))
                  }, [
                    _createTextVNode(_toDisplayString(_unref(t)('dashboard.plugin.calltoaction.learnmore')) + " ", 1),
                    _cache[7] || (_cache[7] = _createElementVNode("span", { "aria-hidden": "true" }, "→", -1))
                  ])
                ]),
                _createElementVNode("p", {
                  class: "mx-auto mt-6 max-w-3xl text-lg/8 text-pretty text-gray-600",
                  innerHTML: _unref(t)('dashboard.plugin.calltoaction.subtitle')
                }, null, 8, _hoisted_7)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!dataLoaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(1, (i) => {
              return _createElementVNode("div", {
                key: i,
                class: "border border-gray-300 rounded-lg shadow-sm overflow-hidden bg-white px-4 py-5 sm:p-6 animate-pulse"
              }, _cache[8] || (_cache[8] = [
                _createElementVNode("dt", { class: "truncate text-sm font-medium text-gray-300" }, " ... ", -1),
                _createElementVNode("dd", { class: "mt-1 h-8 bg-gray-200 rounded w-3/4" }, null, -1)
              ]))
            }), 64))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedMetadataArray.value, (content) => {
              return (_openBlock(), _createElementBlock("li", {
                key: content.plugin.name
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(PluginHeader, {
                    plugin: content.plugin,
                    "enable-link": true
                  }, null, 8, ["plugin"]),
                  _createVNode(ListPluginReportsTable, {
                    plugin: content.plugin,
                    metadatas: content.metadatas,
                    "page-limit": pageLimit
                  }, null, 8, ["plugin", "metadatas"])
                ])
              ]))
            }), 128))
          ]),
          (hasOnePluginAndNoMetadatas.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("h2", _hoisted_15, _toDisplayString(_unref(t)('dashboard.plugin.initialSetup.title')), 1),
                    _createElementVNode("p", {
                      class: "mx-auto mt-6 max-w-3xl text-lg/8 text-pretty text-gray-600",
                      innerHTML: _unref(t)('dashboard.plugin.initialSetup.subtitle')
                    }, null, 8, _hoisted_16),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("a", {
                        href: "#",
                        class: "rounded-md bg-teal-500 px-3.5 py-2.5 text-lg font-semibold text-white shadow-xs hover:bg-teal-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-700",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (openPluginLivesPage()), ["prevent"]))
                      }, _toDisplayString(_unref(t)('dashboard.plugin.initialSetup.download-ebook')), 1),
                      _createElementVNode("a", {
                        href: "#",
                        class: "text-sm/6 font-semibold text-gray-900",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (navigateWhatsapp(_unref(t)('dashboard.plugin.initialSetup.help'))))
                      }, [
                        _createTextVNode(_toDisplayString(_unref(t)('dashboard.plugin.initialSetup.help')) + " ", 1),
                        _cache[9] || (_cache[9] = _createElementVNode("span", { "aria-hidden": "true" }, "→", -1))
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])),
    _createVNode(RightSideDrawer, {
      show: showHelpModal.value,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((showHelpModal).value = $event)),
      "bg-color": "bg-gray-100"
    }, {
      header: _withCtx(() => [
        _createVNode(_component_DialogTitle, { class: "px-4 py-6 sm:px-6" }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(t)('plugins.manager.modal.help.title')), 1),
            _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(t)('plugins.manager.modal.help.description')), 1)
          ]),
          _: 1
        })
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("dl", _hoisted_21, [
            _createElementVNode("div", null, [
              _createElementVNode("dt", _hoisted_22, [
                _createElementVNode("strong", null, _toDisplayString(_unref(t)('plugins.manager.modal.help.permissions.title')), 1),
                _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(t)('plugins.manager.modal.help.permissions.error')), 1)
              ]),
              _createElementVNode("dd", _hoisted_24, [
                _createElementVNode("p", null, _toDisplayString(_unref(t)('plugins.manager.modal.help.permissions.solution')), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("dt", _hoisted_25, [
                _createElementVNode("strong", null, _toDisplayString(_unref(t)('plugins.manager.modal.help.admin.title')), 1),
                _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("p", _hoisted_26, _toDisplayString(_unref(t)('plugins.manager.modal.help.admin.error')), 1)
              ]),
              _createElementVNode("dd", _hoisted_27, [
                _createElementVNode("p", null, _toDisplayString(_unref(t)('plugins.manager.modal.help.admin.solution')), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("dt", _hoisted_28, [
                _createElementVNode("strong", null, _toDisplayString(_unref(t)('plugins.manager.modal.help.link.title')), 1),
                _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("p", _hoisted_29, _toDisplayString(_unref(t)('plugins.manager.modal.help.link.error')), 1)
              ]),
              _createElementVNode("dd", _hoisted_30, [
                _createElementVNode("p", null, _toDisplayString(_unref(t)('plugins.manager.modal.help.link.solution')), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("dt", _hoisted_31, [
                _createElementVNode("strong", null, _toDisplayString(_unref(t)('plugins.manager.modal.help.selection.title')), 1),
                _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("p", _hoisted_32, _toDisplayString(_unref(t)('plugins.manager.modal.help.selection.error')), 1)
              ]),
              _createElementVNode("dd", _hoisted_33, [
                _createElementVNode("p", null, _toDisplayString(_unref(t)('plugins.manager.modal.help.selection.solution')), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("dt", _hoisted_34, [
                _createElementVNode("strong", null, _toDisplayString(_unref(t)('plugins.manager.modal.help.personal.title')), 1),
                _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("p", _hoisted_35, _toDisplayString(_unref(t)('plugins.manager.modal.help.personal.error')), 1)
              ]),
              _createElementVNode("dd", _hoisted_36, [
                _createElementVNode("p", null, _toDisplayString(_unref(t)('plugins.manager.modal.help.personal.solution')), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("dt", _hoisted_37, [
                _createElementVNode("strong", null, _toDisplayString(_unref(t)('plugins.manager.modal.help.token.title')), 1),
                _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("p", _hoisted_38, _toDisplayString(_unref(t)('plugins.manager.modal.help.token.error')), 1)
              ]),
              _createElementVNode("dd", _hoisted_39, [
                _createElementVNode("p", null, _toDisplayString(_unref(t)('plugins.manager.modal.help.token.solution')), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "button",
                class: "inline-flex w-full shrink-0 items-center justify-center rounded-md bg-teal-500 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-teal-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-500 sm:flex-1",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (navigateWhatsapp(_unref(t)('plugins.manager.modal.help.button1'))))
              }, _toDisplayString(_unref(t)('plugins.manager.modal.help.button1')), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(PluginConnectDrawer, {
      show: showCreateModal.value,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((showCreateModal).value = $event))
    }, null, 8, ["show"])
  ], 64))
}
}

})